import React from "react";
//import "./ExitBotIndicatorView.scss";
import {CHANGE_TAKE_PROFIT} from "../../../../actions/create-bot-type";
import { connect , useDispatch} from "react-redux";
import { Card,Accordion,Form, InputGroup } from "react-bootstrap";
import TutorialPopup from "../../../help/TutorialPopup";
import * as HelpContent from "../../../../utils/HelpContent";
import { Trans } from "react-i18next";

const PriceExitView = (props) => {
  const { newBot,t } = props;
  const isBuy = newBot.strategy=='Long';
  const side = isBuy ? t("sell") : t("buy");
  const actionTrigger = isBuy ? t("more") : t("less");
  const dispatch = useDispatch();
  const changePriceExit = (val) => {
    dispatch({
      type: CHANGE_TAKE_PROFIT,
      payload: val,
    });
  };
  const  restrictAlphabets = (e)=>{
    var x = e.which || e.keycode;
    if(!(x>=46 && x<=57))
      e.preventDefault()
  }
  return (
    <>
      <Card>
        <Accordion.Toggle as={Card.Header} eventKey="3">
          4. {t("exit-cond")}
          {<TutorialPopup content={t("exitConditionPriceBot-help")} />}
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="3">
          <Card.Body>
            <Form.Group>
                  <Form.Label>
                  <Trans i18nKey={"price-cond"}>{{side}} {{actionTrigger}}</Trans>
                  </Form.Label>
                      <InputGroup>
                        <Form.Control
                          as="input"
                          type="number"
                          placeholder=""
                          value={newBot.takeProfit}
                          onChange={(e) => {
                            changePriceExit(e.target.value);
                          }}
                          onKeyPress={(e) => {
                            restrictAlphabets(e);
                         }}
                        ></Form.Control>
                        <InputGroup.Append>
                          <InputGroup.Text>{newBot.quoteCoin}</InputGroup.Text>
                        </InputGroup.Append>
                      </InputGroup>
                </Form.Group>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
    </>
  );
};

export default connect(null)(PriceExitView);
